import Modal from '../../../../shared/Modal';
import CreateAccountForm from '../../../contact/CreateAccountForm';

const ModalProfile = ({
    user,
    open,
    permissions,
    setOpen,
    closeActive,
    updateUser,
    setCloseActive,
    logout,
    losesAccess,
    message
}) => {  
    return (
        <Modal isOpen={open} onClose={() => setOpen(false)} title="Perfil completo" closeActive={closeActive}>
            {(close) => ( 
            <div className='p-8 mt-8 mb-8'>
                <CreateAccountForm 
                onBackToLogin={(us) => updateUser(us)}
                mode={'get'}
                userlogin={user}
                onClose={close}
                permissions={permissions}
                logout={logout}
                losesAccess={losesAccess}
                closeActive={setCloseActive}
                message={message}
                />
            </div>
            )}
        </Modal>
    );
};

export default ModalProfile;